var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        "nudge-bottom": 3,
        "nudge-left": 40,
        value: _vm.showTprCalendar,
        bottom: "",
        "offset-y": "",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on: menu, attrs }) {
            return [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on: tooltip }) {
                          return [
                            _vm.canUseCalendar
                              ? _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "grey lighten-2 ml-2",
                                        attrs: { small: "", height: "38" },
                                        on: {
                                          click: function ($event) {
                                            _vm.showTprCalendar = true
                                          },
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    { ...tooltip, ...menu }
                                  ),
                                  [_c("v-icon", [_vm._v("mdi-calendar")])],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [_c("span", [_vm._v("TPR Interactive Schedule")])]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-card",
        { staticClass: "fill", attrs: { width: "360" } },
        [
          _c("v-card-title", { staticClass: "pb-0 text-subtitle-1" }, [
            _vm._v(" TPR Interactive Schedule "),
          ]),
          _c(
            "v-card",
            { attrs: { flat: "", align: "center" } },
            [
              _c(
                "v-form",
                { ref: "s_form", staticClass: "fill" },
                [
                  _c("v-divider"),
                  _c("v-date-picker", {
                    attrs: {
                      "allowed-dates": (date) => new Date(date).getDay() === 6,
                      "show-current": true,
                      events: _vm.eventDates,
                      "event-color": _vm.getEventColorForDate,
                      "show-adjacent-months": "",
                      color: "primary",
                      "no-title": "",
                      "full-width": "",
                    },
                    model: {
                      value: _vm.interactiveDateSelection,
                      callback: function ($$v) {
                        _vm.interactiveDateSelection = $$v
                      },
                      expression: "interactiveDateSelection",
                    },
                  }),
                  _c("v-divider"),
                ],
                1
              ),
            ],
            1
          ),
          _vm.interactiveDateSelection
            ? _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c("v-card-title", { staticClass: "text-h6" }, [
                    _vm._v(
                      " TPR Date: " + _vm._s(_vm.interactiveDateSelection) + " "
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _vm._l(_vm.eventData, function (event) {
                        return _c(
                          "p",
                          { key: event.name, staticClass: "black--text" },
                          [
                            _c(
                              "v-chip",
                              {
                                staticClass: "mr-2 event-chip-width",
                                attrs: {
                                  color: event.color,
                                  small: "",
                                  dark: "",
                                },
                              },
                              [_vm._v(" " + _vm._s(event.name) + " ")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(event.value) +
                                " @ " +
                                _vm._s(event.time) +
                                " "
                            ),
                          ],
                          1
                        )
                      }),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          "* Publishing also generates Export 25 and Storewise files"
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }